import { Entity } from '@api/api/entity-schema';
import { Button } from '@design/components/button/Button';
import {
  ListEntityItem,
  ListEntityItemProps,
} from '@terminal/components/search-modal/components/list-entity-item/ListEntityItem';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './SearchAssetItem.module.scss';

export interface SearchAssetItem extends Omit<ListEntityItemProps, 'onClick'> {
  entity: Entity;
  isAdded: boolean;
  isFocused: boolean;
  onClick?: (item: Entity, isInWatchlist: boolean) => void;
}

export const SearchAssetItem = ({
  entity,
  isAdded,
  isFocused,
  isDisabled,
  onClick,
  ...rest
}: SearchAssetItem) => {
  const { t } = useTranslation('widget');
  const handleClick = onClick
    ? (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        onClick(entity, isAdded);
      }
    : undefined;

  return (
    <ListEntityItem
      entity={entity}
      isFocused={isFocused}
      isDisabled={isDisabled}
      onClick={handleClick}
      actionNode={
        <Button
          className={clsx(styles.styledButton, {
            [styles.isActive]: isAdded,
          })}
          data-testid="search-asset-item-button"
          size="xsmall"
          variant="tertiary"
          iconName={isAdded ? 'Checkmark' : 'Add'}
          aria-label={
            isAdded
              ? t('widget:search.removeAsset')
              : t('widget:search.addAsset')
          }
          tabIndex={-1}
          disabled={isDisabled}
        />
      }
      data-testid="search-asset-item"
      {...rest}
    />
  );
};
